import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["item"];
import React from 'react';
import { CrownDiamond } from '@gravity-ui/icons';
import { Icon } from '@gravity-ui/uikit';
import { block } from '../../utils/cn';
import { Highlight } from '../Highlight/Highlight';
import { DescDelimiter } from './DescDelimiter';
import { Row } from './Row';
import './GroupRow.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var b = block('search-group-row');
function GroupRowLead(_ref) {
  var lead = _ref.lead,
    type = _ref.type;
  return /*#__PURE__*/_jsxs("span", {
    className: b('lead'),
    children: [/*#__PURE__*/_jsx(Icon, {
      data: CrownDiamond,
      size: 14,
      className: b('lead-icon', {
        type: type
      })
    }), /*#__PURE__*/_jsx("span", {
      className: b('lead-name'),
      children: /*#__PURE__*/_jsx(Highlight, {
        text: lead.name
      })
    })]
  });
}
export function GroupRow(_ref2) {
  var item = _ref2.item,
    otherProps = _objectWithoutProperties(_ref2, _excluded);
  var leadType = item['chief'] ? 'chief' : 'deputy';
  var lead = item[leadType];
  var description = /*#__PURE__*/_jsxs(_Fragment, {
    children: [lead !== null && lead !== void 0 && lead.name ? /*#__PURE__*/_jsx(GroupRowLead, {
      lead: lead,
      type: leadType
    }) : null, lead !== null && lead !== void 0 && lead.name && item.parent ? /*#__PURE__*/_jsx(DescDelimiter, {}) : null, /*#__PURE__*/_jsx(Highlight, {
      text: item.parent
    })]
  });
  return /*#__PURE__*/_jsx(Row, _objectSpread({
    description: description,
    item: item
  }, otherProps));
}
// #sourceMappingURL=GroupRow.js.map